/* facts-duocap.js · FACTS
   Zwei Aufgaben, mehr nicht:
   1. Das Video laeuft EINMAL, wenn die Sektion ins Bild kommt, und haelt
      danach auf dem letzten Bild stehen. Autoplay per Attribut wuerde es
      schon abspielen, waehrend niemand hinsieht - und danach steht die
      geoeffnete Kapsel da, ohne dass jemand das Oeffnen gesehen hat.
   2. Die Beschriftungen erscheinen, wenn die Kapsel zur Ruhe gekommen ist.
      Ohne dieses Skript sind sie von Anfang an sichtbar (die Klasse
      fdc--js wird erst hier gesetzt) - eine Beschriftung, die nur mit
      JavaScript existiert, existiert fuer Suchmaschinen und Vorlesegeraete
      gar nicht.
*/
(function () {
  'use strict';

  function boot(root) {
    if (root.dataset.fdcReady === '1') return;
    root.dataset.fdcReady = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var video = root.querySelector('[data-fdc-video]');
    var delay = parseInt(root.getAttribute('data-reveal'), 10);
    if (isNaN(delay) || delay < 0) delay = 900;

    root.classList.add('fdc--js');

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      root.classList.add('is-shown');
    }

    // Source URLs stay inert until the capsule approaches the viewport.
    // Reduced-motion visitors retain the open-capsule poster without video bytes.
    function loadSources() {
      if (!video) return;
      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      for (var j = 0; j < sources.length; j++) {
        sources[j].src = sources[j].getAttribute('data-src');
        sources[j].removeAttribute('data-src');
      }
      video.load();
    }
    if (reduce) { show(); return; }
    if (video && 'IntersectionObserver' in window) {
      var preloadObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          loadSources();
          preloadObserver.disconnect();
        }
      }, { rootMargin: '400px 0px', threshold: 0 });
      preloadObserver.observe(video);
    }

    // Ohne IntersectionObserver gibt es keinen sinnvollen Startpunkt -
    // dann laeuft das Video sofort und die Schrift steht sofort.
    if (!('IntersectionObserver' in window)) {
      loadSources();
      if (video) { video.setAttribute('autoplay', ''); var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () {}); }
      show();
      return;
    }

    if (reduce) {
      // Kein Abspielen, kein Einblenden: das Poster steht, die Schrift steht.
      show();
      return;
    }

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.disconnect();
        if (started) return;
        started = true;

        if (video) {
          loadSources();
          spielAb(video, show);
          // Der Ruhezustand ist das Ende des Videos. Die eingestellte
          // Verzoegerung ist nur die Notbremse, falls kein 'ended' kommt.
          video.addEventListener('ended', show, { once: true });
          window.setTimeout(show, delay + 6000);
          if (root.getAttribute('data-loop') === 'pendeln') pendeln(video);
        }
        window.setTimeout(show, delay);
        return;
      }
    }, { threshold: 0.35 });

    io.observe(root);
  }

  /* BEFUND 02.09. (Julian: "sometimes ... doesnt move"): ein einzelnes
     video.play() ist auf dem Telefon keine Zusage. Es scheitert regelmaessig
     und aus Gruenden, die nichts mit der Seite zu tun haben - im
     Stromsparmodus von iOS ist Autoplay generell gesperrt, und ein play()
     vor 'canplay' kann bei knapper Verbindung abgewiesen werden. Die alte
     Fassung fing den Fehlschlag ab und tat dann nichts mehr: Poster steht,
     Kapsel bewegt sich nie. Genau das "sometimes".

     Drei Versuche in aufsteigender Verzweiflung:
       1. sofort,
       2. sobald genug Daten da sind ('canplay'),
       3. bei der ersten Nutzergeste - eine Geste hebt jede
          Autoplay-Sperre auf, auch die des Stromsparmodus.
     Klappt gar nichts, wird auf das ENDE des Videos gesprungen. Dann steht
     die geoeffnete Kapsel da, auf die sich die Beschriftungen beziehen -
     nicht die geschlossene aus dem Poster, die ihnen widerspricht. */
  function spielAb(video, show) {
    var fertig = false;
    var gesteAn = false;

    function aufraeumen() {
      if (gesteAn) {
        document.removeEventListener('touchstart', versuch, true);
        document.removeEventListener('click', versuch, true);
        gesteAn = false;
      }
    }

    function versuch() {
      if (fertig) return;
      var p = video.play();
      if (!p || !p.then) { fertig = true; aufraeumen(); return; }
      p.then(function () { fertig = true; aufraeumen(); })
       .catch(function () {
         // Die Schrift darf nicht auf ein Ereignis warten, das nie kommt.
         show();
         if (!gesteAn) {
           gesteAn = true;
           document.addEventListener('touchstart', versuch, true);
           document.addEventListener('click', versuch, true);
         }
       });
    }

    video.addEventListener('canplay', function () { if (!fertig) versuch(); }, { once: true });
    // Letzte Rueckfallebene: die Ruhelage ist das Ende, nicht der Anfang.
    window.setTimeout(function () {
      if (fertig || !video.duration || !isFinite(video.duration)) return;
      try { video.currentTime = video.duration; } catch (e) {}
    }, 4000);
    versuch();
  }

  // Vorwaerts, dann RUECKWAERTS, dann wieder vorwaerts. Browser koennen kein
  // negatives playbackRate - der Rueckwaertslauf wird deshalb Bild fuer Bild
  // ueber currentTime gezogen. Bewusst auf rund 30 Schritte je Sekunde
  // gedrosselt: jedes Setzen von currentTime ist ein Suchlauf, und sechzig
  // davon je Sekunde lassen aeltere Telefone haengen.
  function pendeln(video) {
    var raf = 0;
    var STEP = 1 / 30;

    function rueckwaerts() {
      var last = 0;
      function schritt(now) {
        if (!last) last = now;
        var dt = (now - last) / 1000;
        if (dt >= STEP) {
          last = now;
          var t = video.currentTime - dt;
          if (t <= 0.02) {
            video.currentTime = 0;
            cancelAnimationFrame(raf);
            raf = 0;
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
            return;
          }
          video.currentTime = t;
        }
        raf = requestAnimationFrame(schritt);
      }
      raf = requestAnimationFrame(schritt);
    }

    video.addEventListener('ended', function () {
      video.pause();
      if (!raf) rueckwaerts();
    });

    // Laeuft die Sektion aus dem Bild, haelt das Pendel an - ein Suchlauf je
    // Bild fuer etwas, das niemand sieht, ist verschenkte Rechenzeit.
    // BEFUND 31.08. (Julian): beim Wegscrollen hielt das Video an und lief
    // beim Zurueckscrollen nicht wieder los - der Beobachter kannte nur den
    // Fall "verlaesst das Bild". Jetzt kennt er beide Richtungen: raus
    // pausiert, rein setzt fort. Laeuft gerade der Rueckwaertslauf, wird er
    // beim Zurueckkommen neu angestossen, sonst bliebe das Bild stehen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) {
            if (raf) continue;
            if (video.ended || video.currentTime >= video.duration - 0.05) {
              rueckwaerts();
            } else {
              spielAb(video, function () {});
            }
          } else {
            if (raf) { cancelAnimationFrame(raf); raf = 0; }
            video.pause();
          }
        }
      }, { threshold: 0 }).observe(video);
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-fdc]');
    for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Der Theme-Editor haengt Sektionen neu ein, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelectorAll ? e.target.querySelectorAll('[data-fdc]') : [];
    for (var i = 0; i < n.length; i++) boot(n[i]);
  });
})();